import { getSchemaVariables } from 'stitfr-form-js-viewer';
import { useService } from './usePropertiesPanelService';

/**
 * Retrieve list of variables from the form schema.
 *
 * @returns { string[] } list of variables used in form schema
 */
export function useVariables() {
  const form = useService('formEditor');
  const schema = form.getSchema();

  return getSchemaVariables(schema);
}
